<template>
  <v-app id="detalle-comprobacion-amex">
    <v-dialog v-model="dialogNewComprobacion" fullscreen hide-overlay :persistent="true"
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Detalle de solicitud de comprobación AMEX
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <v-select v-model="solicitud.estado_cuenta" :disabled="true" :items="estados_cuenta"
                    :item-text="item => `${item.tarjetahabiente} - ${item.periodo}`" item-value="idestado_cuenta_amex"
                    label="Estados de cuenta" />
                  <br />
                  <v-text-field v-model="solicitud.tipo_solicitud" label="Tipo de solicitud" disabled
                    box></v-text-field>
                  <v-flex xs12 sm12 md6>
                    <v-select v-model="solicitud.tipo_pago" :items="tipos_pago" :disabled="true"
                      label="Tipo de Pago"></v-select>
                  </v-flex>
                  <div v-if="firmas && firmas.length">
                    <h3 class="grey--text">FIRMAS</h3><br />
                    <v-list three-line dark>
                      <div v-for="(item, i) in firmas" :key="`firma-${i}`">
                        <v-list-tile class="pb-2 pt-2">
                          <v-list-tile-content>
                            <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                            <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                            <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                              v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                      </div>
                    </v-list>
                  </div>
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-container>
                  <h3 class="grey--text">Resumen del estado de cuenta seleccionado</h3>
                  <br />
                  <v-data-table :headers="headersEC" :items="estado_cuenta_seleccionado" :loading="loading"
                    class="elevation-1" hide-actions>
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="{ item }">
                      <tr>
                        <td class="text-xs-center">{{ item.tarjetahabiente }}</td>
                        <td class="text-xs-center">{{ formatDateShort(item.fecha_corte) }}</td>
                        <td class="text-xs-center">{{ formatDateShort(item.fecha_pago) }}</td>
                        <td class="text-xs-center">{{ formatCurrency(item.saldo_a_pagar) }}</td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div class="text-xs-center">No se ha seleccionado estado de cuenta.</div>
                    </template>
                  </v-data-table>
                  <br />
                  <br />
                  <h3 class="grey--text">COMPROBANTES</h3><br />
                  <v-text-field v-model="solicitud.comprobantes.no_comprobantes" class="pt-3" label="No. Comprobantes"
                    box readonly></v-text-field>
                  <v-layout wrap>
                    <v-flex xs12 sm6>
                      <v-btn small block color="blue-grey" class="white--text" @click="dialogNewCom = true"
                        :loading="loading" :disabled="true">
                        Agregar
                        <v-icon small right dark>add_circle</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-btn :disabled="solicitud.comprobantes.detalle.length == 0" small block :loading="loading"
                        color="blue-grey" class="white--text" @click="showDetailCom()">
                        Mostrar
                        <v-icon small right dark>remove_red_eye</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                      <v-btn small color="blue-grey" class="white--text" @click="descargarTodo" :loading="loading">
                        DESCARGAR TODO
                        <v-icon small right dark>cloud_download</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field v-model="solicitud.comprobantes.subtotal" label="Subtotal" box prefix="$"
                        suffix="MXN" readonly></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field v-model="solicitud.comprobantes.iva" label="IVA" box prefix="$" suffix="MXN"
                        readonly></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-text-field v-model="solicitud.comprobantes.importe_total" label="Importe por reembolsar" prefix="$"
                    suffix="MXN" box readonly></v-text-field>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" right>
      {{ msgError }}
    </v-snackbar>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComprobantes" max-width="1200px">
      <v-card>
        <v-card-title class="headline justify-center">
          Comprobantes
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="headersComprobantes" :items="solicitud.comprobantes.detalle" class="elevation-1"
            hide-default-footer>
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td class="text-xs-center">{{ item.tipo_gasto }}</td>
                <td class="text-xs-center">{{ getConceptoDesc(item.concepto) }}</td>
                <td class="text-xs-center">{{ formatDateShort(item.fecha_timbrado) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.subtotal) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.iva) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.descuento) }}</td>
                <td class="text-xs-center">{{ formatCurrency(item.total) }}</td>
                <td class="text-xs-center">{{ item.uuid }}</td>
                <td class="text-xs-center">
                  <v-tooltip bottom v-if="item.data">
                    <v-btn slot="activator" small icon @click="verDetalleComprobante(item)">
                      <v-icon>visibility</v-icon>
                    </v-btn>
                    <span>Ver detalle</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.id, 'pdf')">
                      <v-icon>picture_as_pdf</v-icon>
                    </v-btn>
                    <span>Descargar PDF</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.id, 'foto')">
                      <v-icon>image</v-icon>
                    </v-btn>
                    <span>Descargar Foto</span>
                  </v-tooltip>

                  <v-tooltip v-if="item.tipo_gasto == 'Deducible'" bottom>
                    <v-btn slot="activator" small icon @click="descargarArchivo(item.id, 'xml')">
                      <v-icon>code</v-icon>
                    </v-btn>
                    <span>Descargar XML</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="detailSolCom">
                    <v-btn slot="activator" icon small @click="descargarArchivo(item.id, 'todo')">
                      <v-icon>archive</v-icon>
                    </v-btn>
                    <span>Descargar Todo</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="estatusSolicitud">
                    <v-btn slot="activator" small icon @click="eliminarComprobante(item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <span>Eliminar</span>
                  </v-tooltip>
                </td>

              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogComprobantes = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetCom" max-width="800px">
      <v-card>
        <v-card-title class="headline grey--text text--darken-2">
          Detalle del Comprobante
        </v-card-title>
        <v-card-text v-if="comprobanteSeleccionado">
          <v-container>
            <v-layout wrap>
              <v-flex xs12 sm6><strong>Tipo de Gasto:</strong> {{ comprobanteSeleccionado.tipo_gasto }}</v-flex>
              <v-flex xs12 sm6><strong>RFC:</strong> {{ comprobanteSeleccionado.rfc }}</v-flex>
              <v-flex xs12 sm6><strong>Beneficiario:</strong> {{ comprobanteSeleccionado.beneficiario }}</v-flex>
              <v-flex xs12 sm6><strong>Folio:</strong> {{ comprobanteSeleccionado.folio }}</v-flex>
              <v-flex xs12 sm6><strong>UUID:</strong> {{ comprobanteSeleccionado.uuid }}</v-flex>
              <v-flex xs12 sm6><strong>Fecha Timbrado:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_timbrado)
              }}</v-flex>
              <v-flex xs12 sm6><strong>Subtotal:</strong> {{ formatCurrency(comprobanteSeleccionado.subtotal)
              }}</v-flex>
              <v-flex xs12 sm6><strong>IVA:</strong> {{ formatCurrency(comprobanteSeleccionado.iva) }}</v-flex>
              <v-flex xs12 sm6><strong>Descuento:</strong> {{ formatCurrency(comprobanteSeleccionado.descuento)
              }}</v-flex>
              <v-flex xs12 sm6><strong>Total:</strong> {{ formatCurrency(comprobanteSeleccionado.total) }}</v-flex>
              <v-flex xs12><strong>Concepto:</strong> {{ comprobanteSeleccionado.idcat_concepto.descripcion }} ({{
                comprobanteSeleccionado.idcat_concepto.subcuenta }})</v-flex>
              <v-flex xs12 sm6><strong>Cuenta:</strong> {{ comprobanteSeleccionado.idcat_concepto.cuenta }}</v-flex>
              <v-flex xs12 sm6><strong>Subcuenta:</strong> {{ comprobanteSeleccionado.idcat_concepto.subcuenta
              }}</v-flex>
              <v-flex xs12 sm6><strong>Fecha Creación:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_creacion)
              }}</v-flex>
              <v-flex xs12 sm6><strong>Última Actualización:</strong> {{
                formatDateShort(comprobanteSeleccionado.fecha_actualizacion) }}</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDetCom = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import services from "@/config/services";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { decimal, maxValue, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "DetalleComprobacionAMEX",
  mixins: [validationMixin],
  validations: {
    solicitud: {
      comprobantes: {
        importe_total: {
          required: requiredIf(function () {
            return true;
          }),
          decimal,
          minValue: minValue(0.01),
          maxValue: maxValue(999999.99)
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      success: false,
      error: false,
      msgSuccess: "",
      msgError: "",
      dialogNewComprobacion: true,
      dialogNewCom: false,
      dialogComprobantes: false,
      dialogDetCom: false,
      comprobanteSeleccionado: null,
      detailSolCom: false,
      tipos_pago: ['Transferencia', 'Cheque'],
      estatusSolicitud: true,
      solicitud: {
        tipo_solicitud: "Comprobación AMEX",
        tipo_pago: null,
        estado_cuenta: null,
        comprobantes: {
          importe_total: 0,
          no_comprobantes: 0,
          descuento: 0,
          subtotal: 0,
          iva: 0,
          detalle: []
        }
      },
      estados_cuenta: [],
      estado_cuenta_seleccionado: [],
      firmas: [],
      headersEC: [
        {
          text: "Tarjetahabiente",
          value: "tarjetahabiente",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Corte",
          value: "fecha_corte",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Pago",
          value: "fecha_pago",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Saldo a pagar",
          value: "saldo_a_pagar",
          sortable: false,
          class: "text-xs-center"
        }
      ],
      headersComprobantes: [
        {
          text: "Tipo de Gasto",
          value: "tipo_gasto",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Concepto",
          value: "concepto",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Fecha Timbrado",
          value: "fecha_timbrado",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Subtotal",
          value: "subtotal",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "IVA",
          value: "iva",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Descuento",
          value: "descuento",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Total",
          value: "total",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "UUID",
          value: "uuid",
          sortable: false,
          class: "text-xs-center"
        },
        {
          text: "Acciones",
          value: "acciones",
          sortable: false,
          class: "text-xs-center"
        }
      ]
    };
  },
  async mounted() {
    await this.detalleSolicitud();
  },
  methods: {
    handleClose() {
      this.$router.back();
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${pad(d.getFullYear())}`;
    },
    showDetailCom() {
      this.dialogComprobantes = true;
    },
    getConceptoDesc(concepto) {
      if (!concepto) return '';
      if (typeof concepto === 'object' && concepto.descripcion) {
        const subcuenta = concepto.subcuenta || '';
        return subcuenta ? `${subcuenta} - ${concepto.descripcion}` : concepto.descripcion;
      }
      return concepto;
    },
    verDetalleComprobante(item) {
      this.dialogDetCom = true;
      this.comprobanteSeleccionado = item.data;
    },
    async descargarArchivo(id, tipo) {
      try {
        const jwt = this.$session.get("jwt");
        const headers = {
          Authorization: "Bearer " + jwt
        };

        const params = new URLSearchParams();
        params.append("idcomprobante_amex", id);
        params.append("tipo", tipo);

        const response = await axios.get(
          `${services.routes.amexComprobanteDescarga}?${params.toString()}`,
          {
            headers,
            responseType: "blob"
          }
        );

        const disposition = response.headers["content-disposition"];
        if (!disposition) {
          this.msgError = "Archivo no Disponible";
          this.error = true;
          return;
        }
        let filename = "archivo";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition.split("filename=")[1].replace(/["']/g, "");
        }
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error("Error al descargar comprobante:", err);
        this.error = true;
        if (err && err.response && err.response.data && err.response.data.message) {
          this.msgError = err.response.data.message;
        } else if (err && err.message) {
          this.msgError = err.message;
        } else {
          this.msgError = "Error al descargar el comprobante";
        }
      }
    },
    eliminarComprobante(item) {
      if (confirm('¿Deseas eliminar este comprobante?')) {
        // Implementar eliminación del comprobante
        console.log('Eliminar comprobante:', item);
      }
    },
    async descargarTodo() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.descargarComprobantesComprobacionAMEX.replace(
          ":idsolicitud",
          id
        );

        const response = await axios.get(url, { headers, responseType: "blob" });

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Comprobantes-Comprobacion-AMEX-${id}.zip`;
        link.click();
        window.URL.revokeObjectURL(link.href);

      } catch (err) {
        this.error = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
        console.error("Error al descargar comprobantes:", err);
      } finally {
        this.loading = false;
      }
    },
    async detalleSolicitud() {
      this.loading = true;
      const id = this.$route.params.id;
      const jwt = this.$session.get("jwt");
      const headers = { Authorization: "Bearer " + jwt };

      const url = services.routes.amexComprobacionDetalle.replace(":id", id);

      try {
        const response = await axios.get(url, { headers });
        const data = response.data;

        // Mapear datos del response
        this.solicitud.tipo_solicitud = data.tipo_solicitud;
        this.solicitud.tipo_pago = data.tipo_pago;
        this.solicitud.comprobantes.importe_total = parseFloat(data.importe_total);
        this.solicitud.comprobantes.no_comprobantes = data.comprobantes_amex && Array.isArray(data.comprobantes_amex) ? data.comprobantes_amex.length : 0;

        // Estado de cuenta
        if (data.idestado_cuenta_amex) {
          this.estados_cuenta = [data.idestado_cuenta_amex];
          this.estado_cuenta_seleccionado = [data.idestado_cuenta_amex];
          this.solicitud.estado_cuenta = data.idestado_cuenta_amex.idestado_cuenta_amex;
        }

        // Comprobantes
        if (data.comprobantes_amex && Array.isArray(data.comprobantes_amex)) {
          let subtotal = 0;
          let iva = 0;
          let descuento = 0;

          data.comprobantes_amex.forEach(c => {
            subtotal += parseFloat(c.subtotal) || 0;
            iva += parseFloat(c.iva) || 0;
            descuento += parseFloat(c.descuento) || 0;

            this.solicitud.comprobantes.detalle.push({
              id: c.idcomprobante_amex,
              tipo_gasto: c.tipo_gasto,
              concepto: c.idcat_concepto,
              fecha_timbrado: c.fecha_timbrado,
              subtotal: c.subtotal,
              iva: c.iva,
              descuento: c.descuento,
              total: c.total,
              uuid: c.uuid,
              data: c
            });
          });

          this.solicitud.comprobantes.subtotal = subtotal.toFixed(2);
          this.solicitud.comprobantes.iva = iva.toFixed(2);
          this.solicitud.comprobantes.descuento = descuento.toFixed(2);
        }

        // Firmas
        if (data.firmas && Array.isArray(data.firmas)) {
          this.firmas = data.firmas;
        }

        // Estatus
        if (data.idcat_estatus && data.idcat_estatus.idcat_estatus === 1) {
          this.estatusSolicitud = true;
        } else {
          this.estatusSolicitud = false;
        }
      } catch (err) {
        this.error = true;
        if (err && err.response && err.response.data) {
          this.msgError = err.response.data.message || "Error del servidor";
        } else {
          this.msgError = err.message || "Error desconocido";
        }
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 80px;
  line-height: 90px;
  font-weight: 700;
  color: #252932;
  text-shadow: rgba(61, 61, 61, 0.3) 1px 1px, rgba(61, 61, 61, 0.2) 2px 2px,
    rgba(61, 61, 61, 0.3) 3px 3px;
}
</style>
